import { ActiveInactiveStatusEnum } from '../../../shared/enums/active-inactive-status.enum';
import { globalTheme } from '../../../shared/theme/theme';
import { TextToColorMapModel } from '../../shared/models/text-to-color-map.model';

export const firmwareOverviewStatusMap: Map<
  ActiveInactiveStatusEnum,
  TextToColorMapModel
> = new Map([
  [
    ActiveInactiveStatusEnum.ACTIVE,
    {
      textContent: 'Active',
      textColor: globalTheme.palette.black.main,
    },
  ],
  [
    ActiveInactiveStatusEnum.INACTIVE,
    {
      textContent: 'Inactive',
      textColor: globalTheme.palette.black.main,
    },
  ],
]);
